export const EXTERNAL_TRAINING_ERROR_CODES = [
  "EXTERNAL_TRAINING_EXEMPTION_NOT_ENROLLED",
  "EXTERNAL_TRAINING_EXEMPTION_NOT_EXEMPTABLE",
  "EXTERNAL_TRAINING_EXEMPTION_REJECTED",
  "EXTERNAL_TRAINING_EXEMPTION_LEARNER_NOT_VISIBLE",
  "RESOURCE_NOT_EDITABLE",
];

export const findExternalTrainingErrorCode = (
  error: any,
): string | undefined => {
  const body = JSON.stringify(error?.response?.data ?? "");
  return EXTERNAL_TRAINING_ERROR_CODES.find((code) => body.includes(code));
};
